import { Link } from "react-router-dom";
import { Building2, MapPin, Phone, Mail, ArrowRight } from "lucide-react";

export default function Footer() {
  return (
    <footer className="bg-slate-900 text-white" data-testid="footer">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 lg:py-20">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          <div className="lg:col-span-1">
            <div className="flex items-center gap-2.5 mb-5">
              <div className="h-9 w-9 rounded-lg bg-sky-500 flex items-center justify-center">
                <Building2 className="h-5 w-5 text-white" />
              </div>
              <div>
                <span className="font-heading text-lg font-extrabold tracking-tight leading-none text-white">LEGACY</span>
                <span className="font-heading text-[10px] font-bold tracking-[0.3em] block leading-none text-amber-400">HEIGHTS</span>
              </div>
            </div>
            <p className="text-slate-400 text-sm leading-relaxed">
              Premium student accommodation designed for academic success, personal growth, and unforgettable university experiences.
            </p>
          </div>
          <div>
            <h4 className="font-heading font-bold text-xs uppercase tracking-[0.25em] mb-5 text-sky-400">Quick Links</h4>
            <div className="space-y-3">
              <Link to="/rooms" className="flex items-center gap-2 text-sm text-slate-400 hover:text-white transition-colors group">
                <ArrowRight className="h-3 w-3 text-amber-500 group-hover:translate-x-0.5 transition-transform" /> Browse Rooms
              </Link>
              <Link to="/register" className="flex items-center gap-2 text-sm text-slate-400 hover:text-white transition-colors group">
                <ArrowRight className="h-3 w-3 text-amber-500 group-hover:translate-x-0.5 transition-transform" /> Apply Now
              </Link>
              <Link to="/login" className="flex items-center gap-2 text-sm text-slate-400 hover:text-white transition-colors group">
                <ArrowRight className="h-3 w-3 text-amber-500 group-hover:translate-x-0.5 transition-transform" /> Sign In
              </Link>
            </div>
          </div>
          <div>
            <h4 className="font-heading font-bold text-xs uppercase tracking-[0.25em] mb-5 text-sky-400">Contact</h4>
            <div className="space-y-3">
              <div className="flex items-start gap-2.5 text-sm text-slate-400">
                <MapPin className="h-4 w-4 shrink-0 mt-0.5 text-amber-500" /> 123 University Drive, Harare, Zimbabwe
              </div>
              <div className="flex items-center gap-2.5 text-sm text-slate-400">
                <Phone className="h-4 w-4 shrink-0 text-amber-500" /> +263 242 000 000
              </div>
              <div className="flex items-center gap-2.5 text-sm text-slate-400">
                <Mail className="h-4 w-4 shrink-0 text-amber-500" /> info@legacyheights.co.zw
              </div>
            </div>
          </div>
          <div>
            <h4 className="font-heading font-bold text-xs uppercase tracking-[0.25em] mb-5 text-sky-400">Office Hours</h4>
            <div className="space-y-2 text-sm text-slate-400">
              <p>Mon - Fri: 8:00 AM - 5:00 PM</p>
              <p>Saturday: 9:00 AM - 1:00 PM</p>
              <p>Sunday: Closed</p>
              <p className="pt-2 text-amber-400 font-medium">24/7 Security On-Site</p>
            </div>
          </div>
        </div>
        <div className="mt-16 pt-8 border-t border-white/10 flex flex-col sm:flex-row justify-between items-center gap-4">
          <p className="text-xs text-slate-500">&copy; {new Date().getFullYear()} Legacy Heights Student Accommodation. All rights reserved.</p>
          <p className="text-xs text-slate-500">Harare, Zimbabwe</p>
        </div>
      </div>
    </footer>
  );
}
